/* unplugin-vue-components disabled */import { render } from "./onboarding-research.vue?vue&type=template&id=53b7b95d&scoped=true"
import script from "./onboarding-research.vue?vue&type=script&lang=js"
export * from "./onboarding-research.vue?vue&type=script&lang=js"

import "./onboarding-research.vue?vue&type=style&index=0&id=53b7b95d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b7b95d"],['__file',"src/components/ai-chat/ai-assistant/research/onboarding-research.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53b7b95d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53b7b95d', __exports__)) {
    api.reload('53b7b95d', __exports__)
  }
  
  module.hot.accept("./onboarding-research.vue?vue&type=template&id=53b7b95d&scoped=true", () => {
    api.rerender('53b7b95d', render)
  })

}


export default __exports__